
import { Component, Prop, Vue } from 'vue-property-decorator';

import {
  Dialog,
  Upload,
  Card,
  Link,
} from 'element-ui';
import api from '@/api/course';
import { Message } from '@/plugin/message/index';

@Component({
  components: {
    Dialog,
    Upload,
    Card,
    Link,
  },
})

export default class uploadModal extends Vue {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: false,
    default: '附件上传',
  }) title!: string;

  @Prop({
    required: false,
  }) row!: any;

  private fileName:any = '';

  get isHtmlResource() {
    return Number(this.row && this.row.resourceType) === 16;
  }

  mounted() {
    this.getAttachment();
  }

  /**
   * @author liangyongmou
   * @desc 获取所有合同图片
   */
  getAttachment() {
    api.getFile(this.row.pid).then((res: any) => {
      this.fileName = res.data.path;
    }).catch(() => {
      this.fileName = '';
    });
  }

  /**
   * @author liangyongmou
   * @desc 上传之前事件
   * @param { any } file 当前上传的图片
   */
  handleBeforeUpload(file: any) {
    if ([14, 15].includes(Number(this.row.resourceType)) && (!/\.(cpp|cc|cxx)$/i.test(file.name) || file.size > 1024 * 1024)) {
      Message.error('请上传不超过 1 MB 的 UTF-8 C++ 源码文件');
      return false;
    }
    if (this.isHtmlResource && !String(file.name || '').toLowerCase().endsWith('.zip')) {
      Message.error('HTML教学工具仅支持上传 ZIP 包');
      return false;
    }

    const data:FormData = new FormData();
    data.append('pid', this.row.pid);
    data.append('resourcePath', file);

    api.uploadFile(data).then(() => {
      this.reset(true);
      this.getAttachment();
    });
    return false;
  }

  // 重置表单
  reset(close: boolean = false) {
    if (close) this.$emit('update:visible', false);
    this.$emit('refrsh');
  }
}
